import { useState, useMemo } from 'react';
import { pathOr } from 'ramda';
import { InsurancePlanAssignmentStatusType, PlanCategoryType } from 'generated/types';
import { usePlansWithBenefitsQuery } from 'apollo/queries/PLANS_WITH_BENEFITS';
import { getInsurancePlanOptionValue } from '../helpers';
var MedicalCare = PlanCategoryType.MedicalCare, DentalCare = PlanCategoryType.DentalCare, VisionCare = PlanCategoryType.VisionCare;
var categories = [MedicalCare, DentalCare, VisionCare];
var useCostEstimationForm = function (form, entity, member_id) {
    var _a = useState(true), isOutOfNetworkSelected = _a[0], setIsOutOfNetworkSelected = _a[1];
    var _b = useState((entity === null || entity === void 0 ? void 0 : entity.insurance_plan) || form.getFieldValue('insurance_plan')), insuranceSelected = _b[0], setInsuranceSelected = _b[1];
    var _c = usePlansWithBenefitsQuery({
        variables: {
            filters: {
                member_id: member_id,
                categories: categories,
                eligibility_status: InsurancePlanAssignmentStatusType.Current
            }
        },
        fetchPolicy: 'cache-first'
    }), loading = _c.loading, data = _c.data;
    var plans = pathOr([], ['insurance_plans', 'nodes'], data);
    var medicalPlan = useMemo(function () { return plans.find(function (_a) {
        var category = _a.category;
        return (category === null || category === void 0 ? void 0 : category.code) === MedicalCare;
    }); }, [plans]);
    var hasMedicalCare = Boolean(medicalPlan);
    var medicalPlanValue = (medicalPlan === null || medicalPlan === void 0 ? void 0 : medicalPlan.id) || false;
    var insuranceOptions = categories.map(function (item) {
        return getInsurancePlanOptionValue(plans, item);
    });
    var isLocationDisabled = medicalPlanValue !== insuranceSelected ||
        !hasMedicalCare ||
        isOutOfNetworkSelected;
    return {
        loading: loading,
        insuranceSelected: insuranceSelected,
        setInsuranceSelected: setInsuranceSelected,
        hasMedicalCare: hasMedicalCare,
        insuranceOptions: insuranceOptions,
        plans: plans,
        isLocationDisabled: isLocationDisabled,
        setIsOutOfNetworkSelected: setIsOutOfNetworkSelected
    };
};
export default useCostEstimationForm;
